import { Pipe, PipeTransform } from '@angular/core';
@Pipe({name: 'financial'})
export class FinancialPipe implements PipeTransform {
  transform(value, type: string, unit: string, change: boolean): string {
    if (!value) return '-';
    else {
        if (value === 0) return '-';
        else if (isNaN(value)) return value;
        else {
            if (!type || !unit) return value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            else if (change && (type.toLowerCase() === 'net w/c (mb)' || type.toLowerCase() === 'net cfo (mb)' || type.toLowerCase() === 'net cfi (mb)' || type.toLowerCase() === 'capex (mb)' || type.toLowerCase() === 'net cff (mb)' || type.toLowerCase() === 'dividend paid (mb)' || type.toLowerCase() === 'net cash flow (mb)' || type.toLowerCase() === 'calendar days (days)')) return value.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            else if (change) return value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            else if (unit.toLowerCase() === 'mb') return value.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            else return value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
  }
}


// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/pipe/financial.pipe.ts